import server from './server';

/**
 * @description: login
 * @param {string} username
 * @param {string} password
 * @return {Promise} promise
 * */
export const login = (data) => {
  return server({
    url: '/admin/login',
    method: 'POST',
    data,
  });
};
/**
 * @description: admin delete
 * @return {Promise} promise
 * */
export const adminDelete = (id) => {
  return server({
    url: `/admin/user/${id}/`,
    method: 'DELETE',
  });
};
/**
 * @description: create admin
 * @param {string} username
 * @param {string} password
 * @param {number} can_manage_sleep
 * @return {Promise} promise
 * */
export const adminCreate = (data) => {
  return server({
    url: '/admin/user/',
    method: 'POST',
    data,
  });
};
/**
 * @description: admin list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @return {Promise} promise
 * */
export const adminList = (params) => {
  return server({
    url: '/admin/user/',
    method: 'GET',
    params,
  });
};
/**
 * @description: admin change
 * @param {string} password
 * @param {number} active 0hide 1show
 * @param {array} menu
 * @param {string} username
 * @return {Promise} promise
 * */
export const adminChange = ({ id, ...data }) => {
  return server({
    url: `/admin/user/${id}/`,
    method: 'PATCH',
    data,
  });
};
/**
 * @description: member list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @param {number} is_library 0 1
 * @param {number} is_publish 0 1
 * @param {number} active 0 1
 * @param {number} disable 0 1
 * @return {Promise} promise
 * */
export const memberList = (params) => {
  return server({
    url: '/admin/member/',
    method: 'GET',
    params,
  });
};
/**
 * @description: change member username
 * @param {string} username
 * @return {Promise} promise
 * */
export const changeMemberUsername = ({ id, ...data }) => {
  return server({
    url: `/admin/member/${id}`,
    method: 'PATCH',
    data,
  });
};
/**
 * @description: member detail
 * @return {Promise} promise
 * */
export const memberDetail = (id) => {
  return server({
    url: `/admin/member/${id}/`,
    method: 'GET',
  });
};
/**
 * @description: member change
 * @param {string} password
 * @param {number} active 0hide 1show
 * @return {Promise} promise
 * */
export const memberChange = ({ id, ...data }) => {
  return server({
    url: `/admin/member/${id}/`,
    method: 'PATCH',
    data,
  });
};
/**
 * @description: member add
 * @param {string} password
 * @param {string} real_name
 * @param {string} username
 * @return {Promise} promise
 * */
export const addMember = (data) => {
  return server({
    url: `/admin/member/`,
    method: 'POST',
    data,
  });
};
/**
 * @description: member edit
 * @param {string} real_name
 * @param {string} username
 * @return {Promise} promise
 * */
export const editMember = (id, data) => {
  console.log(id);
  return server({
    url: `/admin/member/${id}/`,
    method: 'PUT',
    data,
  });
};
/**
 * @description: member delete
 * @return {Promise} promise
 * */
export const delMember = (id) => {
  return server({
    url: `/admin/member/${id}/`,
    method: 'DELETE',
  });
};
/**
 * @description: member attendance list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @param {number} user_id
 * @return {Promise} promise
 * */
export const memberAttendanceList = (params) => {
  return server({
    url: `/admin/user_attendance/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: member comment list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @param {number} user_id
 * @return {Promise} promise
 * */
export const memberCommentList = (params) => {
  return server({
    url: `/admin/user_comment/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: member discuss list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @param {number} user_id
 * @return {Promise} promise
 * */
export const memberDiscussList = (params) => {
  return server({
    url: `/admin/user_discuss/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: send mail history
 * @param {number} page
 * @param {number} page_size
 * @return {Promise} promise
 * */
export const sendHistory = (params) => {
  return server({
    url: `/admin/send_mail_history/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: carousel list
 * @return {Promise} promise
 * */
export const carouselList = (params) => {
  return server({
    url: `/admin/banner/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: carousel add
 * @param {string} title
 * @param {string} image
 * @param {string} link jump to
 * @param {number} order
 * @return {Promise} promise
 * */
export const carouselAdd = (data) => {
  return server({
    url: `/admin/banner/`,
    method: 'POST',
    data,
  });
};
/**
 * @description: carousel detail
 * @return {Promise} promise
 * */
export const carouselDetail = (id) => {
  return server({
    url: `/admin/banner/${id}/`,
    method: 'GET',
  });
};
/**
 * @description: carousel change
 * @param {string} title
 * @param {string} image
 * @param {string} link jump to
 * @param {number} order
 * @param {number} active 0hide 1show
 * @return {Promise} promise
 * */
export const carouselChange = ({ id, ...data }) => {
  return server({
    url: `/admin/banner/${id}/`,
    method: 'PATCH',
    data,
  });
};
/**
 * @description: carousel delete
 * @return {Promise} promise
 * */
export const carouselDelete = (id) => {
  return server({
    url: `/admin/banner/${id}/`,
    method: 'DELETE',
  });
};
/**
 * @description: service introduce
 * @return {Promise} promise
 * */
export const getServiceIntroduce = (id) => {
  return server({
    url: `/admin/service/${id}/`,
    method: 'GET',
  });
};
/**
 * @description: service introduce edit
 * @param {string} content
 * @return {Promise} promise
 * */
export const editServiceIntroduce = ({ id, ...data }) => {
  return server({
    url: `/admin/service/${id}/`,
    method: 'PUT',
    data,
  });
};
/**
 * @description: setting list
 * @return {Promise} promise
 * */
export const settingList = () => {
  return server({
    url: `/admin/service_term/`,
    method: 'GET',
  });
};
/**
 * @description: setting detail
 * @return {Promise} promise
 * */
export const settingDetail = (id) => {
  return server({
    url: `/admin/service_term/${id}/`,
    method: 'GET',
  });
};
/**
 * @description: setting edit
 * @return {Promise} promise
 * */
export const settingEdit = ({ id, ...data }) => {
  return server({
    url: `/admin/service_term/${id}/`,
    method: 'PUT',
    data,
  });
};
/**
 * @description: FAQ list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @return {Promise} promise
 * */
export const getFAQ = (params) => {
  return server({
    url: `/admin/faq/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: FAQ delete
 * @return {Promise} promise
 * */
export const deleteFAQ = (id) => {
  return server({
    url: `/admin/faq/${id}/`,
    method: 'DELETE',
  });
};
/**
 * @description: FAQ detail
 * @return {Promise} promise
 * */
export const getFAQDetail = (id) => {
  return server({
    url: `/admin/faq/${id}/`,
    method: 'GET',
  });
};
/**
 * @description: FAQ add
 * @return {Promise} promise
 * */
export const addFAQ = (data) => {
  return server({
    url: `/admin/faq/`,
    method: 'POST',
    data,
  });
};
/**
 * @description: FAQ edit
 * @return {Promise} promise
 * */
export const editFAQ = ({ id, ...data }) => {
  return server({
    url: `/admin/faq/${id}/`,
    method: 'PUT',
    data,
  });
};
/**
 * @description: QA list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @param {number} status 0 1
 * @return {Promise} promise
 * */
export const getQA = (params) => {
  return server({
    url: `/admin/qa/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: QA detail
 * @return {Promise} promise
 * */
export const getQADetail = (id) => {
  return server({
    url: `/admin/qa/${id}/`,
    method: 'GET',
  });
};
/**
 * @description: QA edit
 * @param {string} answer
 * @return {Promise} promise
 * */
export const editQA = ({ id, ...data }) => {
  return server({
    url: `/admin/qa/${id}/`,
    method: 'PATCH',
    data,
  });
};
/**
 * @description: QA delete
 * @return {Promise} promise
 * */
export const deleteQA = (id) => {
  return server({
    url: `/admin/qa/${id}/`,
    method: 'DELETE',
  });
};
/**
 * @description: notice list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @param {number} active 0 1
 * @param {number} is_home 0 1
 * @return {Promise} promise
 * */
export const noticeList = (params) => {
  return server({
    url: `/admin/notice/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: notice detail
 * @return {Promise} promise
 * */
export const noticeDetail = (id) => {
  return server({
    url: `/admin/notice/${id}/`,
    method: 'GET',
  });
};
/**
 * @description: notice add
 * @param {string} title
 * @param {string} subtitle
 * @param {string} content
 * @param {number} order
 * @param {number} is_home
 * @param {string} cover
 * @return {Promise} promise
 * */
export const addNotice = (data) => {
  return server({
    url: `/admin/notice/`,
    method: 'POST',
    data,
  });
};
/**
 * @description: notice edit
 * @param {string} title
 * @param {string} subtitle
 * @param {string} content
 * @param {number} order
 * @param {number} is_home
 * @param {string} cover
 * @param {number} active  1show 0hide
 * @return {Promise} promise
 * */
export const editNotice = ({ id, ...data }) => {
  return server({
    url: `/admin/notice/${id}/`,
    method: 'PUT',
    data,
  });
};
/**
 * @description: notice delete
 * @return {Promise} promise
 * */
export const deleteNotice = (id) => {
  return server({
    url: `/admin/notice/${id}/`,
    method: 'DELETE',
  });
};
/**
 * @description: activity userList
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @param {number} activity
 * @param {number} status 0 1 2
 * @param {number} activity__type 1 2
 * @return {Promise} promise
 * */
export const activity_userList = (params) => {
  return server({
    url: `/admin/user_activity/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: activity userList edit
 * @param {number} status 1agree 2refuse
 * @param {string} refuse_reason
 * @return {Promise} promise
 * */
export const edit_activity_userList = ({ id, ...data }) => {
  return server({
    url: `/admin/user_activity/${id}/`,
    method: 'PATCH',
    data,
  });
};
/**
 * @description: activity userList delete
 * @return {Promise} promise
 * */
export const delete_activity_userList = (id) => {
  return server({
    url: `/admin/user_activity/${id}/`,
    method: 'DELETE',
  });
};
/**
 * @description: activity userList multiple_update
 * @return {Promise} promise
 * */
export const multiple_update_activity_userList = (data) => {
  return server({
    url: `/admin/user_activity/multiple_update/`,
    method: 'PATCH',
    data,
  });
};

export const add_user_activity = (data) => {
  return server({
    url: `/admin/activity_excel_upload/`,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
  });
};
/**
 * @description: activity add
 * @param {number} start_time
 * @param {number} end_time
 * @param {number} apply_start
 * @param {number} apply_end
 * @param {string} title
 * @param {string} content
 * @param {string} cover
 * @param {number} type  1 2
 * @param {number} total_num
 * @param {number} order
 * @param {number} apply_type 0 1
 * @param {string} external_link
 * @return {Promise} promise
 * */
export const addActivity = (data) => {
  return server({
    url: `/admin/activity/`,
    method: 'POST',
    data,
  });
};
/**
 * @description: activity list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @param {number} type 1 2
 * @param {number} status 0 1 2 3 4 5
 * @param {number} active 0 1
 * @return {Promise} promise
 * */
export const activityList = (params) => {
  return server({
    url: `/admin/activity/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: activity detail
 * @return {Promise} promise
 * */
export const activityDetail = (id) => {
  return server({
    url: `/admin/activity/${id}/`,
    method: 'GET',
  });
};
/**
 * @description: activity edit
 * @param {number} start_time
 * @param {number} end_time
 * @param {number} apply_start
 * @param {number} apply_end
 * @param {string} title
 * @param {string} content
 * @param {string} cover
 * @param {number} type  1 2
 * @param {number} total_num
 * @param {number} order
 * @param {number} apply_type 0 1
 * @param {string} external_link
 * @return {Promise} promise
 * */
export const editActivity = ({ id, ...data }) => {
  return server({
    url: `/admin/activity/${id}/`,
    method: 'PUT',
    data,
  });
};
/**
 * @description: activity delete
 * @return {Promise} promise
 * */
export const deleteActivity = (id) => {
  return server({
    url: `/admin/activity/${id}/`,
    method: 'DELETE',
  });
};
/**
 * @description: coupon add
 * @param {number} start_time
 * @param {number} end_time
 * @param {string} title
 * @param {number} amount
 * @param {number} total_num
 * @param {number} redeem_code
 * @return {Promise} promise
 * */
export const addCoupon = (data) => {
  return server({
    url: `/admin/coupon/`,
    method: 'POST',
    data,
  });
};
/**
 * @description: coupon list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @param {number} type 0 1
 * @param {number} status 0 1 2
 * @return {Promise} promise
 * */
export const couponList = (params) => {
  return server({
    url: `/admin/coupon/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: coupon detail
 * @return {Promise} promise
 * */
export const couponDetail = (id) => {
  return server({
    url: `/admin/coupon/${id}/`,
    method: 'GET',
  });
};

/**
 * @description: coupon add member
 * @param {number} coupon_id
 * @param {array} user_ids
 * @return {Promise} promise
 * */
export const couponAddMember = (data) => {
  return server({
    url: `/admin/coupon/${data.coupon_id}/assign-users/`,
    method: 'POST',
    data,
  });
};

export const couponDeleteMember = (coupon_id, row_id) => {
  return server({
    url: `/admin/coupon/${coupon_id}/remove-user/${row_id}`,
    method: 'DELETE',
  });
};
/**
 * @description: coupon edit
 * @param {number} start_time
 * @param {number} end_time
 * @param {string} title
 * @param {number} amount
 * @param {number} total_num
 * @param {number} type  0  1
 * @return {Promise} promise
 * */
export const editCoupon = ({ id, ...data }) => {
  return server({
    url: `/admin/coupon/${id}/`,
    method: 'PUT',
    data,
  });
};
/**
 * @description: coupon delete
 * @return {Promise} promise
 * */
export const deleteCoupon = (id) => {
  return server({
    url: `/admin/coupon/${id}/`,
    method: 'DELETE',
  });
};
/**
 * @description: coupon use list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @param {number} coupon
 * @return {Promise} promise
 * */
export const couponUseList = (params) => {
  return server({
    url: `/admin/user_coupon/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: serial list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @return {Promise} promise
 * */
export const serialList = (params) => {
  return server({
    url: `/admin/book/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: serial detail
 * @return {Promise} promise
 * */
export const serialDetail = (id) => {
  return server({
    url: `/admin/book/${id}/`,
    method: 'GET',
  });
};
/**
 * @description: serial add
 * @param {string} title
 * @param {string} detail
 * @param {string} cover
 * @param {string} book_desc
 * @param {string} author_name
 * @param {string} author_desc
 * @param {array} day_of_week
 * @param {string} author_img
 * @param {number} is_recommend
 * @param {number} is_switch_on
 * @param {number} status
 * @param {number} active
 * @param {array} tag  ['book','']
 * @return {Promise} promise
 * */
export const addSerial = (data) => {
  return server({
    url: `/admin/book/`,
    method: 'POST',
    data,
  });
};
/**
 * @description: serial edit
 * @param {string} title
 * @param {string} detail
 * @param {string} cover
 * @param {string} book_desc
 * @param {string} author_name
 * @param {string} author_desc
 * @param {array} day_of_week
 * @param {string} author_img
 * @param {number} is_recommend
 * @param {number} is_switch_on
 * @param {number} status
 * @param {number} active
 * @param {array} tag  ['book','']
 * @return {Promise} promise
 * */
export const editSerial = ({ id, ...data }) => {
  return server({
    url: `/admin/book/${id}/`,
    method: 'PUT',
    data,
  });
};
/**
 * @description: serial delete
 * @return {Promise} promise
 * */
export const deleteSerial = (id) => {
  return server({
    url: `/admin/book/${id}/`,
    method: 'DELETE',
  });
};
/**
 * @description: chapter list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @param {number} book
 * @return {Promise} promise
 * */
export const chapterList = (params) => {
  return server({
    url: `/admin/chapter/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: chapter detail
 * @return {Promise} promise
 * */
export const chapterDetail = (id) => {
  return server({
    url: `/admin/chapter/${id}/`,
    method: 'GET',
  });
};
/**
 * @description: chapter add
 * @param {number} book
 * @param {number} number
 * @param {string} title
 * @param {number} active
 * @param {string} book
 * @param {string} show_time 2020-12-11 08:27
 * @param {number} is_free 0 1
 * @return {Promise} promise
 * */
export const addChapter = (data) => {
  return server({
    url: `/admin/chapter/`,
    method: 'POST',
    data,
  });
};
/**
 * @description: chapter edit
 * @param {number} book
 * @param {number} number
 * @param {string} title
 * @param {number} active
 * @param {string} book
 * @param {string} show_time 2020-12-11 08:27
 * @param {number} is_free 0 1
 * @return {Promise} promise
 * */
export const editChapter = ({ id, ...data }) => {
  return server({
    url: `/admin/chapter/${id}`,
    method: 'PUT',
    data,
  });
};
/**
 * @description: chapter delete
 * @return {Promise} promise
 * */
export const deleteChapter = (id) => {
  return server({
    url: `/admin/chapter/${id}`,
    method: 'DELETE',
  });
};
/**
 * @description: comment list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @return {Promise} promise
 * */
export const commentList = (params) => {
  return server({
    url: `/admin/service_evaluation/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: comment detail
 * @return {Promise} promise
 * */
export const commentDetail = (id) => {
  return server({
    url: `/admin/service_evaluation/${id}/`,
    method: 'GET',
  });
};
/**
 * @description: comment add
 * @param {string} user_name
 * @param {string} service_name
 * @param {number} active
 * @param {object}{content,is_bold} row1
 * @param {object}{content,is_bold} row2
 * @param {object}{content,is_bold} row3
 * @return {Promise} promise
 * */
export const addComment = (data) => {
  return server({
    url: `/admin/service_evaluation/`,
    method: 'POST',
    data,
  });
};
/**
 * @description: comment edit
 * @param {string} user_name
 * @param {string} service_name
 * @param {number} active
 * @param {object}{content,is_bold} row1
 * @param {object}{content,is_bold} row2
 * @param {object}{content,is_bold} row3
 * @return {Promise} promise
 * */
export const editComment = ({ id, ...data }) => {
  return server({
    url: `/admin/service_evaluation/${id}/`,
    method: 'PUT',
    data,
  });
};
/**
 * @description: comment delete
 * @return {Promise} promise
 * */
export const deleteComment = (id) => {
  return server({
    url: `/admin/service_evaluation/${id}/`,
    method: 'DELETE',
  });
};
/**
 * @description: read list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @param {number} type  0  1
 * @param {number} status 0 1 2 3 4 5
 * @param {string} start_time 2020-1-1
 * @param {string} end_time
 * @return {Promise} promise
 * */
export const readList = (params) => {
  return server({
    url: `/admin/club/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: read detail
 * @return {Promise} promise
 * */
export const readDetail = (id) => {
  return server({
    url: `/admin/club/${id}/`,
    method: 'GET',
  });
};
/**
 * @description: read add
 * @param {number} type 0 1
 * @param {string} title
 * @param {string} subtitle
 * @param {string} content
 * @param {string} cover
 * @param {string} option
 * @param {string} option_desc
 * @param {string} other_title
 * @param {string} other_content
 * @param {number} price
 * @param {number} total_num
 * @param {string} start_time 2020-1-1
 * @param {string} end_time
 * @param {string} apply_start
 * @param {string} apply_end
 * @param {string} refund_desc
 * @param {string} search_tag
 * @return {Promise} promise
 * */
export const addRead = (data) => {
  return server({
    url: `/admin/club/`,
    method: 'POST',
    data,
  });
};
/**
 * @description: read edit
 * @param {number} type 0 1
 * @param {string} title
 * @param {string} subtitle
 * @param {string} content
 * @param {string} cover
 * @param {string} option
 * @param {string} option_desc
 * @param {string} other_title
 * @param {string} other_content
 * @param {number} price
 * @param {number} total_num
 * @param {string} start_time 2020-1-1
 * @param {string} end_time
 * @param {string} apply_start
 * @param {string} apply_end
 * @param {string} refund_desc
 * @param {string} search_tag
 * @return {Promise} promise
 * */
export const editRead = ({ id, ...data }) => {
  return server({
    url: `/admin/club/${id}/`,
    method: 'PUT',
    data,
  });
};
/**
 * @description: read delete
 * @return {Promise} promise
 * */
export const deleteRead = (id) => {
  return server({
    url: `/admin/club/${id}/`,
    method: 'DELETE',
  });
};
/**
 * @description: read notice list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @param {number} club
 * @return {Promise} promise
 * */
export const readNoticeList = (params) => {
  return server({
    url: `/admin/club_notice/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: read notice detail
 * @return {Promise} promise
 * */
export const readNoticeDetail = (id) => {
  return server({
    url: `/admin/club_notice/${id}/`,
    method: 'GET',
  });
};
/**
 * @description: read notice add
 * @param {number} club
 * @param {string} title
 * @param {string} order
 * @param {number} active 0 1
 * @param {string} content
 * @return {Promise} promise
 * */
export const addReadNotice = (data) => {
  return server({
    url: `/admin/club_notice/`,
    method: 'POST',
    data,
  });
};
/**
 * @description: read notice edit
 * @param {number} club
 * @param {string} title
 * @param {string} order
 * @param {number} active 0 1
 * @param {string} content
 * @return {Promise} promise
 * */
export const editReadNotice = ({ id, ...data }) => {
  return server({
    url: `/admin/club_notice/${id}/`,
    method: 'PUT',
    data,
  });
};
/**
 * @description: read notice delete
 * @return {Promise} promise
 * */
export const deleteReadNotice = (id) => {
  return server({
    url: `/admin/club_notice/${id}/`,
    method: 'DELETE',
  });
};
/**
 * @description: read task list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @param {number} club
 * @return {Promise} promise
 * */
export const readTaskList = (params) => {
  return server({
    url: `/admin/club_task/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: read task detail
 * @return {Promise} promise
 * */
export const readTaskDetail = (id) => {
  return server({
    url: `/admin/club_task/${id}/`,
    method: 'GET',
  });
};
/**
 * @description: read task add
 * @param {number} club
 * @param {string} title
 * @param {string} order
 * @param {number} active 0 1
 * @param {string} content
 * @param {string} end_time
 * @return {Promise} promise
 * */
export const addReadTask = (data) => {
  return server({
    url: `/admin/club_task/`,
    method: 'POST',
    data,
  });
};
/**
 * @description: read task edit
 * @param {number} club
 * @param {string} title
 * @param {string} order
 * @param {number} active 0 1
 * @param {string} content
 * @param {string} end_time
 * @return {Promise} promise
 * */
export const editReadTask = ({ id, ...data }) => {
  return server({
    url: `/admin/club_task/${id}/`,
    method: 'PUT',
    data,
  });
};
/**
 * @description: read task delete
 * @return {Promise} promise
 * */
export const deleteReadTask = (id) => {
  return server({
    url: `/admin/club_task/${id}/`,
    method: 'DELETE',
  });
};
/**
 * @description: read comment list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @param {number} club_id
 * @return {Promise} promise
 * */
export const readCommentList = (params) => {
  return server({
    url: `/admin/club_comment/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: read comment detail
 * @return {Promise} promise
 * */
export const readCommentDetail = (id) => {
  return server({
    url: `/admin/club_comment/${id}/`,
    method: 'GET',
  });
};
/**
 * @description: read comment add
 * @param {number} club_id
 * @param {string} title
 * @param {string} content
 * @param {string} commentator
 * @return {Promise} promise
 * */
export const addReadComment = (data) => {
  return server({
    url: `/admin/club_comment/`,
    method: 'POST',
    data,
  });
};
/**
 * @description: read comment edit
 * @param {number} club_id
 * @param {string} title
 * @param {string} content
 * @param {string} commentator
 * @return {Promise} promise
 * */
export const editReadComment = ({ id, ...data }) => {
  return server({
    url: `/admin/club_comment/${id}/`,
    method: 'PUT',
    data,
  });
};
/**
 * @description: read comment delete
 * @return {Promise} promise
 * */
export const deleteReadComment = (id) => {
  return server({
    url: `/admin/club_comment/${id}/`,
    method: 'DELETE',
  });
};

// 엑셀 업로드 club
export const add_user_club = (data) => {
  return server({
    url: `/admin/club_excel_upload/`,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
  });
};

// 엑셀 업로드 coupon
export const add_user_coupon = (data) => {
  return server({
    url: `/admin/coupon_excel_upload/`,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
  });
};

/**
 * @description: attendance list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @param {number} task
 * @return {Promise} promise
 * */
export const attendanceList = (params) => {
  return server({
    url: `/admin/attendance/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: delete attendance

 * @return {Promise} promise
 * */
export const deleteAttendance = (params) => {
  return server({
    url: `/admin/attendance/`,
    method: 'DETELE',
    params,
  });
};
/**
 * @description: read user list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @param {number} club
 * @return {Promise} promise
 * */
export const readUserList = (params) => {
  return server({
    url: `/admin/user_club/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: read user detail
 * @return {Promise} promise
 * */
export const readUserDetail = (id) => {
  return server({
    url: `/admin/user_club/${id}/`,
    method: 'GET',
  });
};
/**
 * @description: read user edit
 * @param {number} user
 * @param {number} club
 * @param {number} status 0 1 2
 * @param {string} refuse_reason
 * @return {Promise} promise
 * */
export const editReadUser = ({ id, ...data }) => {
  return server({
    url: `/admin/user_club/${id}/`,
    method: 'PUT',
    data,
  });
};
/**
 * @description: read user delete
 * @return {Promise} promise
 * */
export const deleteReadUser = (id) => {
  return server({
    url: `/admin/user_club/${id}/`,
    method: 'DELETE',
  });
};
/**
 * @description: update select book option
 * @param {number} order_id
 * @param {number} club_changbi_1 ~ 2
 * @return {Promise} promise
 * */
export const update_club_changbi = (id, data) => {
  return server({
    url: `/admin/user_club/${id}/update-club-changbi/`,
    method: 'PUT',
    data,
  });
};
/**
 * @description: read userList multiple_update
 * @param {string} update_id  1,2,3
 * @param {number} status  1 2
 * @return {Promise} promise
 * */
export const multiple_update_read_userList = (data) => {
  return server({
    url: `/admin/user_club/multiple_update/`,
    method: 'PUT',
    data,
  });
};
/**
 * @description: read userList allow_print
 * @param {string} print_id  1,2,3
 * @param {boolean} status  true false
 * @return {Promise} promise
 * */
export const readUserPrint = (data) => {
  return server({
    url: `/admin/user_club/multiple_print/`,
    method: 'PUT',
    data,
  });
};
/**
 * @description: read user edit
 * @param {number} user
 * @param {number} club
 * @param {number} status 0 1 2
 * @param {string} refuse_reason
 * @return {Promise} promise
 * */
/**
 * @description: read topic list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @param {number} club
 * @return {Promise} promise
 * */
export const readTopicList = (params) => {
  return server({
    url: `/admin/club_discuss/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: read topic delete
 * @return {Promise} promise
 * */
export const deleteReadTopic = (params) => {
  return server({
    url: `/admin/club_discuss/`,
    method: 'DELETE',
    params,
  });
};
/**
 * @description: read topic set top
 * @return {Promise} promise
 * */
export const setReadTopicTop = ({ id, ...data }) => {
  return server({
    url: `/admin/club_discuss/${id}/`,
    method: 'PATCH',
    data,
  });
};
/**
 * @description: attendance comment list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @param {number} attendance
 * @return {Promise} promise
 * */
export const attendanceCommentList = (params) => {
  return server({
    url: `/admin/attendance_comment/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: attendance comment delete
 * @return {Promise} promise
 * */
export const deleteAttendanceComment = (params) => {
  return server({
    url: `/admin/attendance/`,
    method: 'DELETE',
    params,
  });
};
/**
 * @description: order list
 * @param {number} page
 * @param {number} page_size
 * @param {string} search
 * @param {string} ordering
 * @param {number} status 0 1 2
 * @param {string} pay_method card phone trans
 * @param {number} club__type 0 1
 * @param {number} start_time
 * @param {number} end_time
 * @return {Promise} promise
 * */
export const orderList = (params) => {
  return server({
    url: `/admin/order/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: order detail
 * @return {Promise} promise
 * */
export const orderDetail = (id) => {
  return server({
    url: `/admin/order/${id}/`,
    method: 'GET',
  });
};
/**
 * @description: get statistics
 * @return {Promise} promise
 * */
export const getStatistics = () => {
  return server({
    url: `/admin/statistics/`,
    method: 'GET',
  });
};
/**
 * @description: post statistics
 * @param {number} year
 * @param {number} month
 * @return {Promise} promise
 * */
export const postStatistics = (data) => {
  return server({
    url: `/admin/statistics/`,
    method: 'POST',
    data,
  });
};
/**
 * @description: visit_record
 * @param {number} type   (0, "visit website") (1, "visit book")
 * @return {Promise} promise
 * */
export const visitRecord = (data) => {
  return server({
    url: `/admin/visit_record/`,
    method: 'POST',
    data,
  });
};
/**
 * @description: fcm_log
 * @param {number} page
 * @param {number} page_size
 * @return {Promise} promise
 * */
export const fcm_log = (params) => {
  return server({
    url: `/admin/fcm_log/`,
    method: 'GET',
    params,
  });
};
/**
 * @description: post fcm_log
 * @param {string} title
 * @param {string} msg
 * @return {Promise} promise
 * */
export const post_fcm_log = (data) => {
  return server({
    url: `/admin/fcm_log/`,
    method: 'POST',
    data,
  });
};
/**
 * @description: home all book
 * @return {Promise} promise
 * */
export const allBook = () => {
  return server({
    url: `/admin/book/books/`,
    method: 'GET',
  });
};
/**
 * @description: create ip
 * @param {string} ip
 * @return {Promise} promise
 * */
export const IPCreate = (data) => {
  return server({
    url: `/admin/iplist/`,
    method: 'POST',
    data,
  });
};
/**
 * @description: get ip list
 * @return {Promise} promise
 * */
export const IPList = (data) => {
  return server({
    url: `/admin/iplist/`,
    method: 'GET',
    data,
  });
};
/**
 * @description: edit ip
 * @param {string} ip
 * @return {Promise} promise
 * */
export const IPChange = ({ id, ...data }) => {
  return server({
    url: `/admin/iplist/${id}/`,
    method: 'PATCH',
    data,
  });
};
/**
 * @description: delete ip
 * @return {Promise} promise
 * */
export const IPDelete = (id) => {
  return server({
    url: `/admin/iplist/${id}/`,
    method: 'DELETE',
  });
};
/**
 * @description: get log list
 * @return {Promise} promise
 * */
export const LogList = (params) => {
  return server({
    url: `/admin/adminlog/`,
    method: 'GET',
    params,
  });
};

/**
 * @description: upload img
 * @return {Promise} promise
 * */
export const uploadImg = (data) => {
  return server({
    url: '/file_upload',
    method: 'POST',
    data,
  });
};
/**
 * @description: delete img
 * @param {string} username
 * @param {string} password
 * @return {Promise} promise
 * */
export const unloadImg = (data) => {
  return server({
    url: '/file_delete',
    method: 'POST',
    data,
  });
};
